import { Button, Popconfirm, Input, Tag, Tooltip } from "antd";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";

// One row of the History drawer's list — extracted verbatim from
// BuilderComponent.js's List `renderItem` (same JSX, same behavior): either
// the rename input (when this row is being edited) or the normal
// version-tag/name/rename-button display, plus the Restore/Delete actions
// (hidden while editing, matching the original's `editingId === row.id ? [] : [...]`).
function HistoryRow({
    row,
    index,
    isEditing,
    editingValue,
    onEditingValueChange,
    onStartEdit,
    onCancelEdit,
    onRename,
    onRestore,
    onDelete,
}) {
    return {
        actions: isEditing ? [] : [
            <Popconfirm
                key="load"
                title="Restore this snapshot into the editor? Click Publish changes to save it."
                onConfirm={() => onRestore(row.id)}
                okText="Restore"
                cancelText="Cancel"
            >
                <Button size="small">Restore to editor</Button>
            </Popconfirm>,
            <Popconfirm
                key="delete"
                title="Delete this history entry?"
                onConfirm={() => onDelete(row.id)}
                okText="Delete"
                okButtonProps={{ danger: true }}
                cancelText="Cancel"
            >
                <Button size="small" danger icon={<DeleteOutlined />} />
            </Popconfirm>,
        ],
        title: isEditing ? (
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Input
                    autoFocus
                    size="small"
                    value={editingValue}
                    onChange={e => onEditingValueChange(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === "Enter") onRename(row.id, editingValue);
                        if (e.key === "Escape") onCancelEdit();
                    }}
                    style={{ flex: 1 }}
                    placeholder="Enter a name…"
                />
                <Button
                    size="small"
                    type="primary"
                    icon={<CheckOutlined />}
                    onClick={() => onRename(row.id, editingValue)}
                />
                <Button
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={onCancelEdit}
                />
            </span>
        ) : (
            <span style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <Tag style={{ fontSize: 11 }}>v{row.version}</Tag>
                <span style={{ fontSize: 13 }}>
                    {row.name || new Date(row.savedAt).toLocaleString()}
                </span>
                {!row.name && index === 0 && (
                    <Tag color="blue" style={{ fontSize: 11 }}>Previous version</Tag>
                )}
                <Tooltip title="Rename">
                    <Button
                        type="text"
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => onStartEdit(row)}
                        style={{ color: "#8c8c8c" }}
                    />
                </Tooltip>
            </span>
        ),
        description: (
            <span>
                {new Date(row.savedAt).toLocaleString()}
                {row.savedBy ? ` · by ${row.savedBy}` : ""}
            </span>
        ),
    };
}

export { HistoryRow };
